import UseCaseCard from './use-case-card';

export default UseCaseCard;
